/**
 * Client-side store + helpers for password-gated admin tabs.
 *
 * The admin tab password lives ONLY in sessionStorage (per browser tab, so
 * closing the panel logs out of the gate). The backend still enforces the
 * password on /admin/... requests — this module just remembers it so the
 * user doesn't retype on every action.
 */

const KEY = "adminTabPassword";

export function getAdminTabPassword() {
  try {
    return sessionStorage.getItem(KEY) || "";
  } catch {
    return "";
  }
}

export function setAdminTabPassword(password) {
  try {
    if (password) sessionStorage.setItem(KEY, password);
    else sessionStorage.removeItem(KEY);
  } catch {
    // ignore storage errors (private mode)
  }
}

export function clearAdminTabPassword() {
  setAdminTabPassword("");
}

/** true when the admin tab password is needed for this URL path. */
export function requiresAdminTab(url) {
  if (!url) return false;
  const u = String(url);
  return /\/admin\//.test(u);
}